import type { MediaItem } from './media';

export type Tab = 'featured' | 'all' | 'mine' | 'liked';

export const TABS: Tab[] = ['featured', 'all', 'mine', 'liked'];
export const isTab = (v: string | null): v is Tab => TABS.includes(v as Tab);

/**
 * What each tab contains — defined once, for the grid and the viewer both.
 *
 * They cannot be allowed to drift. Photo detail's next/previous walks this
 * list, so a predicate here that disagreed with the gallery's would step onto
 * photographs the tab does not contain. That is not hypothetical: the viewer
 * used to have no predicate at all, so opening the twelfth featured photo and
 * swiping wandered into the other two hundred and thirty-eight, under a header
 * reading "1 of 250".
 *
 * `all` is every photograph. It used to exclude hidden rows; nothing can hide
 * any more (D50) and the attribute is gone.
 */
export function inTab(
  all: MediaItem[],
  tab: Tab,
  viewer: { userId: string } | null,
  liked: Set<string>,
): MediaItem[] {
  if (tab === 'mine') return all.filter((it) => it.uploaderId === viewer?.userId);
  if (tab === 'featured') return all.filter((it) => it.featured);
  if (tab === 'liked') return all.filter((it) => liked.has(it.id));
  return all;
}
